<template>
	<!--顶部 start-->
	<div class="allbox">
	<Header1></Header1>
 
	<div class="RegiserBox">
		<div class="main cf mb60 ">
			<div class="Regiser Boxs">
				<ul class="RegTitle tabTitle">
					<li class="cur">登录账号</li>
					<li><a href="#" >注册账号</a></li>
				</ul>
				<div class="RegMain">
					      <el-form ref="form" :model="form" :rules="rules" class="account-form">
					<div class="tabCon Showbox">
						<ul>
							<li>
								<p class="Tit">账号/手机号码</p>
							<!-- 	<input type="text" name="phone" id="phone" class="iptTxt" v-model="form.phone" placeholder="请输入手机号" > -->
								<!-- <el-input v-model="form.phone" placeholder="请输入手机号"  >
								               <i class="iptTxt"></i>
								              </el-input> -->
											   <el-form-item  prop="phone">
											      <el-input  v-model="form.phone" placeholder="请输入手机号"></el-input>
											    </el-form-item>
											 
							</li>
							<li>
								<p class="Tit" style="padding-top: 0;">密码</p>
								 
								  <el-form-item  prop="password">
								     <el-input type="password"  v-model="form.password" placeholder="请输入密码"></el-input>
								   </el-form-item>
							</li>
							 
						</ul>
						<div class="Check mt25 mb25">
							<label><input type="checkbox" name="">记住密码</label>
						</div>
						<input type="button" class="RedBtn BtnLogin" name="" @click="onSubmit" :disabled="logindis" value="登 录">
						<div class="tac mt50">
							<a href="https://www.chuy1.com/" class="red" target="_blank">找回密码</a>
							| 还没有账号？<a href="https://www.chuy1.com/" class="red" target="_blank">立即注册</a>
						</div>
					</div>
  </el-form>
				</div>

			</div>
		</div>
	</div>
	
	<Footer></Footer>
</div>
</template>

<script>
	import Header1 from '../components/header1.vue'
	import Footer from '../components/footer.vue'
	import {
		login
	} from "../api/api";
	export default {
		name: 'Login',
		components: {
			Header1,
			Footer
		},
		data() {
			return {

				form: {
					phone: '',
					password: '',
					// verifycode: ''
				},
				rules: {
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'change'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'change'
					}]
				},

				logindis: false
			}
		},
		methods: {
			// changeCode() {
			//   console.log('code')
			// },

			onSubmit() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						that.logindis = true
						login({
							phone: this.form.phone,
							password: this.form.password
						}).then(res => {
							console.log(res)
							that.logindis = false
							if (res.code == 1) {
								that.$store.dispatch("logined", {
									jwt_token: res.data.jwt_token,
									uname: res.data.uname
								});
								that.$Message.info('登陆成功');
								setTimeout(function() {
									that.$router.push({
										name: 'Member'
									})
								}, 1500)
							} else {
								that.$Message.info({
									content: res.message,
									type: 'error'
								})
							}
						})
					} else {
						return false;
					}
				});

			}
		}
	}
</script>

<style>
	@import "../assets/css/public.css";
/*注册*/
	.RegiserBox{background: url("../assets/login_bg.png") no-repeat center center;  height: 650px;  padding-top: 62px;
    background-size: cover;
	}
	.RegiserBox .Regiser{margin-left: 740px; }
	.Regiser{padding-bottom: 20px;}

	/*登录注册*/
	.Regiser{width: 460px; background: #fff;font-size: 14px;}
	.RegTitle{height: 64px; background: #f5f5f5}
	.RegTitle li{height: 64px; line-height: 64px; text-align: center; font-size: 16px; width:230px; float: left;}
	.RegTitle li:hover,.RegTitle li.cur{background: #fff; cursor: pointer;}
	
	.RegMain{ padding:20px 60px; }
	.RegMain ul li .Tit{ line-height: 32px; padding-top: 16px;font-weight: bold;}
	.RegMain ul li .iptTxt{height: 38px; line-height: 38px; width: 330px;padding: 0 4px;}
	.RegMain ul li .iptCode{width: 150px}
	.RegMain ul li .ImgCode{width: 160px;height:40px;}
	.RegMain ul li .btnCode{height: 38px; line-height: 38px;border: 1px solid #e8e8e8; width: 150px;background: #f5f5f5; box-sizing: content-box; border-radius: 5px; cursor:pointer}
	.RegMain ul li .State{cursor: auto;}
	.RegMain .BtnLogin{height: 44px; line-height: 44px; width: 340px;border-radius: 5px}
	
	
</style>



// WEBPACK FOOTER //
// src/pages/login.vue
